import { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import withSession from '../../hoc/withSession';
import affiliateValid from '../../apis/affiliate-valid-api';
import GlobalStore from '../../stores/global-store';
import Loading from '../../components/Loading/Loading';
import './Dashboard.css';
import Footer from '../../components/Footer/Footer';

function Dashboard() {
  const {menuOpen, setMenuOpen} = GlobalStore.useContainer();
  const {loading, affID} = GlobalStore.useContainer();
  const [userValid, setUserValid] = useState('');
  const [width, setWidth] = useState(window.innerWidth);
  const navigate = useNavigate();

  useEffect(() => {
    async function checkAffiliateIsValid() {
      const { data } = await affiliateValid.checkIsValid(affID);
      setUserValid(data);
    }

    const timer = setTimeout(() => {
      checkAffiliateIsValid();
    }, 5000);

    return () => clearTimeout(timer);
  }, [affID]);

  useEffect(() => {
    if (userValid?.isValid === 'false') {
      navigate('/profile');
    }
  }, [userValid, navigate]);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  const toggleNavbar = () => {
    if(width < 767) {
      setMenuOpen(prev => !prev);
    }
  };

  return (
    <div className="wrapper">
      <Header onToggleNavbar={toggleNavbar} />
      <main className="main">
        <Sidebar onCloseSidebar={() => setMenuOpen(false)} className={menuOpen ? ' is-open' : ''} />
        <div className="main-content pt-3">
          <div className="main-content__inner">
            <Outlet />
            {loading && (
              <div className="loading-overlay">
                <Loading color="gray" />
              </div> 
            )}
          </div>
          <Footer />
        </div>
      </main>
    </div>
  )
}

export default withSession(Dashboard);
